import { render, staticRenderFns } from "./SectionTitlePreview.vue?vue&type=template&id=727aa049&scoped=true&"
import script from "./SectionTitlePreview.vue?vue&type=script&lang=js&"
export * from "./SectionTitlePreview.vue?vue&type=script&lang=js&"
import style0 from "./SectionTitlePreview.vue?vue&type=style&index=0&id=727aa049&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727aa049",
  null
  
)

export default component.exports